import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { z } from 'zod';
import { apiFetch, apiFetchEmpty } from './client';
import { keys } from './keys';
import { invalidateCommunityAudit } from './communityAudit';

export function useModelAssignments(communityId: string | undefined) {
  return useQuery({
    queryKey: keys.communityModelAssignments(communityId ?? ''),
    enabled: !!communityId,
    queryFn: () =>
      apiFetch(`/api/communities/${communityId}/model-assignments`, z.array(z.record(z.string(), z.unknown()))),
  });
}

export function useAssignCommunityModel(communityId: string | undefined, builderId: string | undefined) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (modelId: number) =>
      apiFetchEmpty(`/api/communities/${communityId}/model-assignments`, {
        method: 'POST',
        body: JSON.stringify({ model_id: modelId }),
      }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: keys.communityModelAssignments(communityId ?? '') });
      void qc.invalidateQueries({ queryKey: keys.communityMtos(communityId ?? '') });
      if (builderId) void qc.invalidateQueries({ queryKey: keys.customerModels(builderId) });
      invalidateCommunityAudit(qc, communityId);
    },
  });
}

export function useUnassignCommunityModel(communityId: string | undefined, builderId: string | undefined) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (modelId: number) =>
      apiFetchEmpty(`/api/communities/${communityId}/model-assignments/${modelId}`, { method: 'DELETE' }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: keys.communityModelAssignments(communityId ?? '') });
      void qc.invalidateQueries({ queryKey: keys.communityMtos(communityId ?? '') });
      if (builderId) void qc.invalidateQueries({ queryKey: keys.customerModels(builderId) });
      invalidateCommunityAudit(qc, communityId);
    },
  });
}
